// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.st0[data-v-86872130]{\n    /* fill:#000000; */\n}\n", ""]);
// Exports
module.exports = exports;
